import { FC, ReactNode } from 'react';
import { Checkbox } from 'antd';

import DropdownOptionContent, {
    type DropdownOptionAvatarProps,
} from '@/shared/components/dropdowns/DropdownOptionContent';

export interface SearchFilterCheckboxOption {
    avatar?: DropdownOptionAvatarProps;
    description?: ReactNode;
    disabled?: boolean;
    icon?: ReactNode;
    label: ReactNode;
    value: string;
}

interface SearchFilterCheckboxListProps {
    onChange: (values: string[]) => void;
    options: SearchFilterCheckboxOption[];
    value: string[];
}

const SearchFilterCheckboxList: FC<SearchFilterCheckboxListProps> = ({ onChange, options, value }) => {
    const updateValue = (optionValue: string, checked: boolean) => {
        if (checked) {
            onChange(value.includes(optionValue) ? value : [...value, optionValue]);
            return;
        }

        onChange(value.filter((selectedValue) => selectedValue !== optionValue));
    };

    return (
        <div aria-label='Search filter options' role='group' style={{ width: '100%' }}>
            {options.map((option) => (
                <label
                    key={option.value}
                    style={{
                        alignItems: option.description ? 'flex-start' : 'center',
                        cursor: option.disabled ? 'not-allowed' : 'pointer',
                        display: 'flex',
                        gap: '0.5rem',
                        minWidth: 0,
                        opacity: option.disabled ? 0.5 : 1,
                        padding: '0.375rem 0',
                        width: '100%',
                    }}
                >
                    <Checkbox
                        checked={value.includes(option.value)}
                        disabled={option.disabled}
                        onChange={(event) => updateValue(option.value, event.target.checked)}
                        style={{ flex: 'none', marginInlineStart: 0 }}
                    />
                    <div style={{ flex: '1 1 auto', minWidth: 0 }}>
                        <DropdownOptionContent
                            avatar={option.avatar}
                            description={option.description}
                            title={option.label}
                            titlePrefix={option.icon}
                        />
                    </div>
                </label>
            ))}
        </div>
    );
};

export default SearchFilterCheckboxList;
